(function() {
    'use strict';

    /**
     * Contrôleur pour la page de connexion
     */
    angular
        .module('observatoireApp')
        .controller('LoginController', ['$scope', '$state', 'Auth', '$window', function($scope, $state, Auth, $window) {
            $scope.user = {};
            $scope.errors = {};
            $scope.loading = false;
            
            // Fonction pour rediriger vers la page d'inscription
            $scope.goToRegister = function() {
                $state.go('register');
            };
            
            // Si l'utilisateur est déjà connecté, rediriger vers la page d'accueil
            if (Auth.isAuthenticated()) {
                $state.go('main.home');
            }

            // Fonction de connexion
            $scope.login = function(form) {
      $scope.submitted = true;
      $scope.loading = true;

      if (form.$valid) {
        Auth.login({
          username: $scope.user.username,
          password: $scope.user.password
        })
        .then(function() {
          // Redirection vers la page précédente ou la page d'accueil
          var referrer = $window.sessionStorage.getItem('referrer') || 'main.home';
          $window.sessionStorage.removeItem('referrer');
          $state.go(referrer);
          $scope.loading = false;
        })
        .catch(function(err) {
          $scope.errors.login = 'Nom d\'utilisateur ou mot de passe incorrect';
          $scope.loading = false;
        });
      } else {
        $scope.loading = false;
      }
    };
  }]);
})();
